import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  getProfileHeightString,
  getProfileWeightString,
  humanize,
  isUndefinedNullEmpty,
  SbCurrentUser,
} from '../submission_boards/component/SbModel';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  LayoutGridIcon,
  MarsIcon,
  Maximize2Icon,
  Minimize2Icon,
  MoveVerticalIcon,
  PlayIcon,
  TextIcon,
  WeightIcon,
} from 'lucide-react';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
import FilePreviewer from '../submission_kits/components/FilePreviewer';
import { KitDocumentModel } from '../submission_kits/components/KitModels';
import ViewMediaModel from '../submission_kits/components/ViewMediaModel';

interface HairMakeupKitProps {
  currentUser: SbCurrentUser;
  user: any;
  showProfileHeader: (show: boolean) => void;
}
// component to show profile photo/age/weight/height
// used by SbDetails and SbDetailsRecipient
export const HairMakeupKit: React.FC<HairMakeupKitProps> = ({ currentUser, user, showProfileHeader }) => {
  const isMobile = useIsMobile();
  const [gridLayout, setgridLayout] = useState(true);
  const [hmuKitDocuments, sethmuKitDocuments] = useState(
    []
  );
  const [featureImage, setfeatureImage] = useState(null);

  const [showMediaBig, setshowMediaBig] = useState<KitDocumentModel | null>(null);
  const [currentMediaIndex, setCurrentMediaIndex] = useState<number>(0);
  const [showTopProfileHeader, setShowTopProfileHeader] = useState(true)

  useEffect(() => {
    let kit_documents = user?.hair_make_up_kit?.hmu_kit_documents;
    if (kit_documents != undefined && kit_documents.length > 0) {
      let sortedDocuments = [...kit_documents].sort((a, b) => {
        if (a.tag === null || b.tag === null) return 1;
        if (a.tag === "" && b.tag !== "") return 1;
        if (a.tag !== "" && b.tag === "") return -1;
        if (a.tag === "" || b.tag === "") return 1;
        return a.tag.localeCompare(b.tag, undefined, { numeric: true });
      });
      if (sortedDocuments[0].tag !== "" && !isMobile) {
        console.log("show desktop");
        const [firstItem, ...remainingItems] = sortedDocuments;
        setfeatureImage(firstItem);
        sethmuKitDocuments(remainingItems);
      } else {
        sethmuKitDocuments(sortedDocuments);
      }
    }
  }, []);
  useEffect(() => {
    let kit_documents = user?.hair_make_up_kit?.hmu_kit_documents;
    if (kit_documents != undefined && kit_documents.length > 0) {
      let sortedDocuments = [...kit_documents].sort((a, b) => {
        if (a.tag === null || b.tag === null) return 1;
        if (a.tag === "" && b.tag !== "") return 1;
        if (a.tag !== "" && b.tag === "") return -1;
        if (a.tag === "" || b.tag === "") return 1;
        return a.tag.localeCompare(b.tag, undefined, { numeric: true });
      });
      if (sortedDocuments[0].tag !== "" && !isMobile) {
        console.log("show desktop");
        const [firstItem, ...remainingItems] = sortedDocuments;
        setfeatureImage(firstItem);
        sethmuKitDocuments(remainingItems);
      } else {
        sethmuKitDocuments(sortedDocuments);
      }
    }
  }, [isMobile]);


  useEffect(() => {
    showProfileHeader(showTopProfileHeader);
  }, [showTopProfileHeader]);

  const renderImage = (index: number, no_of_items: number, feature: boolean) => {
    let mainKitDoc = undefined;
    let isEmpty = true;
    if (feature) {
      mainKitDoc = featureImage;
      isEmpty = !mainKitDoc;
    } else {
      mainKitDoc = hmuKitDocuments[index];
      isEmpty = !mainKitDoc;

    }

    return (
      <div className="flex flex-col gap-5 rounded-lg">
        {isEmpty ? (
          <></>
        ) : (
          <div
            className={
              'relative flex rounded-xl overflow-hidden' + (no_of_items == 1 ? ' flex-1 ' : ' ')
            }
            style={{
              width: no_of_items == 2 ? '9.8125rem' : '20rem',
              // height: no_of_items == 2 ? '9.8125rem' : '20rem',
              aspectRatio: 4 / 5
            }}
            onClick={(e) => {
              e.preventDefault();
              setshowMediaBig(mainKitDoc.kit_document);
            }}
          >
            <FilePreviewer
              dynamicHeight={false}
              object_fit={'object-cover object-top'}
              file_url={
                mainKitDoc.kit_document.cropped_file_url || mainKitDoc.kit_document.file_url
              }
              file_name={mainKitDoc.kit_document.file_name}
              file_content_type={mainKitDoc.kit_document.file_content_type}
            />
          </div>
        )}
      </div>
    );
  };

  const gridBoxItem = (title, value, icon: React.ReactNode) => {
    return (
      <div
        className={"flex flex-col  items-center gap-2-1 border border-blue-502 " +
          (title != null ? ' justify-start ' : ' justify-center ')
        }
        style={{
          padding: '0.375rem',
          borderRadius: '0.625rem',
          color: '#8CA2C280',
          backgroundColor: '#E9EEF6D9',
        }}
      >
        {title != null && (
          <div
            className="flex flex-col justify-end items-center gap-2-1 bg-white w-full"
            style={{
              padding: '0.75rem 0.5rem 0.375rem',
              borderRadius: '0.375rem 0.375rem 0.125rem 0.125rem',
            }}
          >
            <div className="font-normal font-semibold text-13 text-center text-blue-403">
              {title}
            </div>
          </div>
        )}
        <div className="flex flex-col justify-center items-start gap-2-1">
          <div
            className=" flex flex-row justify-center items-center gap-2-1 px-5 py-2-1 text-lg primary-color"
            style={{
              minHeight: '1.875rem',
              minWidth: '8.75rem',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
            }}
          >
            {icon != null && <div id="icon">{icon}</div>}
            <div style={{
              wordWrap: 'break-word',
              whiteSpace: 'pre-line'
            }}>{isUndefinedNullEmpty(value) ? '-' : value}</div>
          </div>
        </div>
      </div>
    );
  };

  const listBoxItem = (title, value) => {
    return (
      <div className="flex flex-col items-start p-0 w-full">
        {title != null && (
          <div
            className="flex flex-row  gap-2-1 w-full"
            style={{
              paddingTop: '0.1875rem',
            }}
          >
            <div className="text-13 font-medium text-left text-blue-403 leading-5"
              style={{ lineHeight: '20px' }}>
              {title}</div>
          </div>
        )}
        <div className="flex flex-col primary-color font-regular text-lg" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
          {value || '-'}
        </div>
      </div>
    );
  };

  const toggleRender = () => {
    return (
      <div
        className="flex flex-row cursor-pointer items-center gap-1-1 rounded-full"
        style={{
          padding: '1rem 0.5rem 1rem 0.5rem',
          backgroundColor: '#A5B7D380',
          maxHeight: '1.625rem',
        }}
        onClick={() => {
          setgridLayout(!gridLayout);
        }}
      >
        <div
          className={
            'flex flex-col items-center gap-2 rounded-full ' + (gridLayout ? 'bg-white' : '')
          }
          style={{
            padding: '0.3125rem 1.125rem 0.3125rem 0.625rem',
            // margin: '0rem -0.625rem',
            zIndex: 1,
          }}
        >
          <LayoutGridIcon className="w-4 h-4" />
        </div>

        <div
          className={
            'flex flex-col items-center gap-2 rounded-full ' + (!gridLayout ? 'bg-white' : '')
          }
          style={{
            padding: '0.3125rem 0.875rem 0.3125rem 0.875rem',
            zIndex: 1,
          }}
        >
          <TextIcon className="w-4 h-4" />
        </div>
      </div>
    );
  };
  const handlePreviousMedia = () => {
    setCurrentMediaIndex((prev) => (prev > 0 ? prev - 1 : hmuKitDocuments.length - 1));
  };

  const handleNextMedia = () => {
    setCurrentMediaIndex((prev) => (prev < hmuKitDocuments.length - 1 ? prev + 1 : 0));
  };

  const renderMediaSection = () => {
    return <> {isMobile ? <>
      {hmuKitDocuments.length > 0 && (
        <div className="flex flex-col items-center p-0 gap-3 w-full">
          <div className="w-full rounded-xl relative overflow-hidden"
            style={{
              aspectRatio: hmuKitDocuments[currentMediaIndex].kit_document.file_content_type?.startsWith('video') ? 16 / 9 : 4 / 5,
              // width: '19rem',
              // height: '19rem'
            }}
            ref={panelRef}
            onTouchStart={handleTouchStartMedia}
            onTouchMove={handleTouchMoveMedia}
            onTouchEnd={handleTouchEndMedia} >
            <div className="w-full h-full relative"
              onClick={(e) => {
                e.preventDefault();
                setshowMediaBig(hmuKitDocuments[currentMediaIndex].kit_document);
              }} >
              <FilePreviewer
                key={`media-${currentMediaIndex}-${hmuKitDocuments[currentMediaIndex]?.kit_document.id
                  || hmuKitDocuments[currentMediaIndex]?.kit_document.file_url || currentMediaIndex}`}
                dynamicHeight={false}
                object_fit={'object-cover object-top'}
                file_url={hmuKitDocuments[currentMediaIndex].kit_document.cropped_file_url || hmuKitDocuments[currentMediaIndex].kit_document.file_url}
                file_name={hmuKitDocuments[currentMediaIndex].kit_document.file_name}
                file_content_type={hmuKitDocuments[currentMediaIndex].kit_document.file_content_type}
              />
              {hmuKitDocuments[currentMediaIndex].kit_document.file_content_type?.startsWith('video') && (
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 box-border flex flex-col justify-center items-center p-3 gap-2.5 w-12 h-12 rounded-full cursor-pointer" style={{ background: 'rgba(0, 0, 0, 0.2)', border: '1px solid #FFFFFF' }}>
                  <PlayIcon size={24} color="#FFFFFF" fill="#FFFFFF" />
                </div>
              )}
            </div>
          </div>

          {/* Media count label - Centered */}
          <div className="flex-none order-0 self-stretch flex-grow-0 text-center  text-xl" style={{ color: '#0D1621', lineHeight: '1.875rem' }}>
            Media ({hmuKitDocuments.length})
          </div>

          {/* Pagination with arrows and dots */}
          {hmuKitDocuments.length > 1 && (
            <div className="flex flex-row items-center justify-center gap-2 w-full py-2">
              <button
                onClick={handlePreviousMedia}
                className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                aria-label="Previous media"
              >
                <ChevronLeftIcon size={20} color="#4B5563" />
              </button>
              <div className="flex flex-row items-center gap-2">
                {hmuKitDocuments.map((_, index) => (
                  <div
                    key={index}
                    className={`rounded-full transition-all ${index === currentMediaIndex ? 'w-2 h-2 bg-blue-500' : 'w-1.5 h-1.5 bg-gray-300'}`}
                  />
                ))}
              </div>
              <button
                onClick={handleNextMedia}
                className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors"
                aria-label="Next media"
              >
                <ChevronRightIcon size={20} color="#4B5563" />
              </button>
            </div>
          )}
        </div>
      )}
    </> : (<><div className="grid grid-cols-1 gap-4">
      {featureImage != null && renderImage(0, 1, true)}
    </div>
      <div className="grid grid-cols-2 gap-4">
        {hmuKitDocuments.map((itemkit, indexKit) => {
          // if (indexKit == 0) {
          //   return <></>;
          // }
          return <>{renderImage(indexKit, 2, false)}</>;
        })}
      </div></>)}
    </>;
  }
  // media slider
  const panelRef = useRef(null);
  const MIN_SWIPE_DISTANCE = 50; // Distance in pixels to confirm a swipe-down close
  const [dragYMedia, setDragYMedia] = useState(0); // Tracks vertical drag distance (for visual feedback)
  // const touchStartY = useRef(0); // Stores the Y position when the touch starts
  const touchStartMedia = useRef({ x: 0, y: 0 });
  const handleTouchStartMedia = (e) => {
    e.stopPropagation();
    // Only track single touch starts on the dialog panel itself
    if (e.touches.length === 1) {
      touchStartMedia.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      };
      setDragYMedia(0); // Reset drag distance
      panelRef.current.style.transition = 'none'; // Disable transition during drag
    }
  };

  const handleTouchMoveMedia = useCallback((e) => {
    e.stopPropagation();
    if (e.touches.length !== 1) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartMedia.current.y;

    // Only allow downward swiping (deltaY > 0)
    if (deltaY > 0) {
      //e.preventDefault(); // Prevent scrolling the main page while dragging the dialog
      setDragYMedia(deltaY);

      // Apply immediate visual translation via inline style
      // if (panelRef.current) {
      //   panelRef.current.style.transform = `translateY(${deltaY}px)`;
      // }
    }
  }, []);

  const handleTouchEndMedia = useCallback(
    (e) => {
      e.stopPropagation();
      if (e.changedTouches.length === 0) return;

      // Get the final touch position
      const touchEnd = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY,
      };

      // Calculate the total change in coordinates
      const deltaX = touchEnd.x - touchStartMedia.current.x;
      const deltaY = touchEnd.y - touchStartMedia.current.y;

      // Calculate the absolute distance moved in each axis
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // --- Check for a deliberate swipe (must move more than the minimum distance) ---
      if (absDeltaX < MIN_SWIPE_DISTANCE && absDeltaY < MIN_SWIPE_DISTANCE) {
        // console.log('Only a small movement (tap or minor drag).');
        return;
      }

      // --- 1. Determine DOMINANT axis ---
      if (absDeltaX > absDeltaY) {
        // Horizontal swipe is dominant
        if (deltaX > 0) {
          handlePreviousMedia();
        } else {
          handleNextMedia();
        }
      } else {
      }
      setDragYMedia(0);
    },
    [dragYMedia]
  );

  // media slider end   
  return (
    <>
      <div
        className="flex flex-col bg-white rounded-2xl border border-blue-502 "
        style={{
          paddingTop: isMobile ? '2.5rem' : '2.5rem', // 40px 60px
          paddingBottom: isMobile ? '2.5rem' : '2.5rem', // 60px
          paddingLeft: isMobile ? '1.25rem' : '3.75rem', // 20px 60px
          paddingRight: isMobile ? '1.25rem' : '3.75rem', // 60px
          gap: isMobile ? '1rem' : '2.5rem', // 60px
        }}
      >
        <div className="flex flex-col sm:flex-row flex-1 justify-between items-center gap-4 border-b border-blue-502">
          <div className="flex flex-row flex-1 items-center">
            <div className={`w-full flex-1 m-0 ${isMobile ? 'h-auto text-3xl leading-9' : 'h-12 text-3xl leading-12'} font-medium tracking-tight`} style={{ color: '#576C89' }}>
              Hair &amp; Makeup Kit</div>
          </div>
          {/* icons */}
          <div className="flex flex-row gap-1-1 pb-4">{toggleRender()}</div>
          {showTopProfileHeader ? <div
            className="w-7 h-7 cursor-pointer hidden sm:flex items-center justify-center  pb-4 pt-2"
            style={{
              color: '#576C89',
            }}
            onClick={() => {
              setShowTopProfileHeader(false);
            }}
          >
            <Maximize2Icon className="w-7 h-7" />
          </div> : <div
            className="w-7 h-7 cursor-pointer  hidden sm:flex items-center justify-center overflow-hidden"
            style={{
              color: '#576C89',
            }}
            onClick={() => {
              setShowTopProfileHeader(true);
            }}
          >
            <Minimize2Icon className="w-7 h-7" />
          </div>}
        </div>
        <div className="flex sm:hidden flex-row gap-10">
          {renderMediaSection()}
        </div>
        <div className="flex flex-row gap-10">
          {/* Left Section */}
          <div className="gap-6 flex flex-col flex-1">
            <div className="flex flex-col sm:flex-row  border-b pb-5 gap-2 sm:gap-5 border-blue-502"
            >
              <h3 className="text-xl font-semibold mb-2" style={{ width: '10.625rem' }}>
                Basics
              </h3>
              <div className="hidden sm:grid grid-cols-3 gap-1 flex-1 w-full">
                {gridBoxItem(null, humanize(user.gender), <MarsIcon className="w-4 h-4 text-blue-403" />)}
                {gridBoxItem(
                  null,
                  getProfileHeightString(user, currentUser),
                  <MoveVerticalIcon className="w-4 h-4  text-blue-403" />
                )}
                {gridBoxItem(
                  null,
                  getProfileWeightString(user, currentUser),
                  <WeightIcon className="w-4 h-4  text-blue-403" />
                )}

              </div>
              <div className="grid sm:hidden grid-cols-1 gap-1 flex-1 w-full">
                {gridBoxItem(null, humanize(user.gender), <MarsIcon className="w-4 h-4  text-blue-403" />)}
              </div>
              <div className="grid sm:hidden grid-cols-2 gap-1 flex-1 w-full">
                {gridBoxItem(
                  null,
                  getProfileHeightString(user, currentUser),
                  <MoveVerticalIcon className="w-4 h-4  text-blue-403" />
                )}
                {gridBoxItem(
                  null,
                  getProfileWeightString(user, currentUser),
                  <WeightIcon className="w-4 h-4  text-blue-403" />
                )}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-5" flex-row="">
              <h3 className="text-xl font-semibold mb-2" style={{ width: '10.625rem' }}>
                Features
              </h3>
              {!gridLayout && (
                <div className="flex flex-col gap-2-1 ">
                  {listBoxItem('Hair', humanize(user.hair_make_up_kit && user.hair_make_up_kit.hair_color))}
                  {listBoxItem('Skin', humanize(user.hair_make_up_kit && user.hair_make_up_kit.skin_tone))}
                  {listBoxItem('Eyes', humanize(user.hair_make_up_kit && user.hair_make_up_kit.eye_color))}
                </div>
              )}
              {gridLayout && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    'Hair',
                    humanize(user.hair_make_up_kit && user.hair_make_up_kit.hair_color),
                    null
                  )}
                  {gridBoxItem(
                    'Skin',
                    humanize(user.hair_make_up_kit && user.hair_make_up_kit.skin_tone),
                    null
                  )}
                  {gridBoxItem(
                    'Eyes',
                    humanize(user.hair_make_up_kit && user.hair_make_up_kit.eye_color),
                    null
                  )}
                </div>
              )}
            </div>

            <div className="hidden flex-col sm:flex-row gap-5" flex-row="">
              <h3 className="text-xl font-semibold mb-1" style={{ width: '10.625rem' }}>
                Allergies
              </h3>

              {!gridLayout && (
                <div className="flex flex-col gap-2-1 flex-1" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {listBoxItem(null, user.hair_make_up_kit && user.hair_make_up_kit.allergies)}
                </div>
              )}
              {gridLayout && (
                <div className="grid grid-cols-1 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    null,
                    user.hair_make_up_kit && user.hair_make_up_kit.allergies,
                    null
                  )}
                </div>
              )}
            </div>

            <div className="flex flex-col sm:flex-row gap-5" flex-row="">
              <h3 className="text-xl font-semibold mb-2 sm:pr-12 pr-0" style={{ width: '10.625rem' }}>
                Other Information
              </h3>
              {!gridLayout && (
                <div className="flex flex-col gap-2-1 ">
                  {listBoxItem('Piercings', user.hair_make_up_kit ? user.hair_make_up_kit.piercings : '-')}
                  {listBoxItem('Allergies', user.hair_make_up_kit && user.hair_make_up_kit.allergies)}
                  {listBoxItem('Tattoos', user.hair_make_up_kit ? user.hair_make_up_kit.tattoos : '-')}
                  {listBoxItem('Notes', user.hair_make_up_kit && user.hair_make_up_kit.notes)}
                </div>
              )}
              {gridLayout && (
                <div className="grid grid-cols-1 sm:grid-cols-1 gap-1 flex-1 w-full">
                  <div className="grid grid-cols-1 gap-1 flex-1 w-full ">
                    {gridBoxItem('Piercings', user.hair_make_up_kit && user.hair_make_up_kit.piercings, null)}
                    {gridBoxItem('Allergies', user.hair_make_up_kit && user.hair_make_up_kit.allergies, null)}
                  </div>
                  <div className="grid grid-cols-1 gap-1 flex-1 w-full ">
                    {gridBoxItem('Tattoos', user.hair_make_up_kit && user.hair_make_up_kit.tattoos, null)}
                    {gridBoxItem('Notes', user.hair_make_up_kit && user.hair_make_up_kit.notes, null)}
                  </div>
                </div>
              )}
            </div>

            <div className="hidden flex-col sm:flex-row gap-5" flex-row="">
              <h3 className="text-xl font-semibold mb-1" style={{ width: '10.625rem' }}>
                Notes
              </h3>
              {!gridLayout && (
                <div className="flex flex-col gap-2-1 flex-1" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {user.hair_make_up_kit && user.hair_make_up_kit.notes ? user.hair_make_up_kit.notes : '-'}
                </div>
              )}
              {gridLayout && (
                <div className="grid grid-cols-1 gap-1 flex-1 w-full">
                  {gridBoxItem(
                    null,
                    user.hair_make_up_kit && user.hair_make_up_kit.notes,
                    null
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Right Section (Images) */}
          <div
            className="hidden sm:flex flex-col gap-1-1"
            style={{
              width: '20rem',
            }}
          >
            {renderMediaSection()}
          </div>
        </div>
        {showMediaBig != null && (
          <>
            <ViewMediaModel
              kit_document={showMediaBig}
              dialogCloseHandler={function (): void {
                setshowMediaBig(null);
              }}
            />
          </>
        )}
      </div>{' '}
    </>
  );
};
